module.exports = __webpack_public_path__ + "static/img/red_alcohol-01.3bda77e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/red_alcohol-01.jpg
// module id = 286
// module chunks = 1